import { Chapter, generateIds } from "."
import storyJson from "../assets/story.json";

/**The Story object is at the highest level of in-game content. It stores the story title and the array of Chapter objects. When story.json is parsed, this object is the result.
 * @param {string} title - The story title.
 * @param {Chapter[]} chapters - An array of Chapter objects, each containing managing their own collection of assets.
*/
export interface Story {
    title: string
    chapters: Chapter[]
}

export function parseStoryJson(): Story {
    const newStory = JSON.parse(JSON.stringify(storyJson)) as Story;
    const chapters = newStory.chapters;
    chapters.forEach(chapter => {generateIds(chapter)});
    return newStory;
}